import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { formatNumber } from "../../../../../../../utils/formatNumber.js";
import { useCustomTheme } from "../../../../../../core/design-system/CustomThemeProvider.js";
import { fontSize, radius, spacing, } from "../../../../../../core/design-system/index.js";
import { useChainName } from "../../../../../../core/hooks/others/useChainQuery.js";
import { useWalletBalance } from "../../../../../../core/hooks/others/useWalletBalance.js";
import { Skeleton } from "../../../../components/Skeleton.js";
import { Container } from "../../../../components/basic.js";
import { Text } from "../../../../components/text.js";
import { TokenSymbol } from "../../../../components/token/TokenSymbol.js";
import { formatTokenBalance } from "../../formatTokenBalance.js";
import { isNativeToken } from "../../nativeToken.js";
import { PayTokenIcon } from "../PayTokenIcon.js";
import { WalletRow } from "../WalletSelectorButton.js";
/**
 * Shows an amount "value" and renders the selected token and chain
 * It also renders the buttons to select the token and chain
 * It also renders the balance of active wallet for the selected token in selected chain
 * @internal
 */
export function PayWithCryptoQuoteInfo(props) {
    const theme = useCustomTheme();
    const { name } = useChainName(props.chain);
    const balanceQuery = useWalletBalance({
        address: props.payerAccount.address,
        chain: props.chain,
        tokenAddress: isNativeToken(props.token) ? undefined : props.token.address,
        client: props.client,
    });
    return (_jsxs(Container, { bg: "tertiaryBg", style: {
            borderRadius: radius.lg,
            border: `1px solid ${theme.colors.borderColor}`,
            ...(props.swapRequired
                ? {
                    borderBottom: "none",
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0,
                }
                : {}),
        }, children: [_jsxs(Container, { flex: "row", gap: "sm", style: {
                    justifyContent: "space-between",
                    padding: spacing.sm,
                    borderBottom: `1px solid ${theme.colors.borderColor}`,
                }, children: [_jsx(WalletRow, { client: props.client, address: props.payerAccount.address }), balanceQuery.data ? (_jsxs(Container, { flex: "row", gap: "3xs", center: "y", children: [_jsx(Text, { size: "xs", color: "secondaryText", weight: 500, children: formatTokenBalance(balanceQuery.data, false) }), _jsx(TokenSymbol, { token: props.token, chain: props.chain, size: "xs", color: "secondaryText" })] })) : (_jsx(Skeleton, { width: "70px", height: fontSize.xs }))] }), _jsxs(Container, { flex: "row", gap: "sm", style: {
                    paddingInline: spacing.sm,
                    paddingBlock: spacing.sm,
                    minWidth: "50%",
                    justifyContent: "flex-start",
                    minHeight: "64px",
                }, children: [_jsx(PayTokenIcon, { token: props.token, chain: props.chain, size: "md", client: props.client }), _jsxs(Container, { flex: "column", gap: "3xs", children: [props.isLoading ? (_jsx(Skeleton, { width: "120px", height: fontSize.md, color: "borderColor" })) : (_jsxs(Container, { flex: "row", gap: "xxs", center: "y", color: "primaryText", children: [_jsx(Text, { size: "md", color: props.value ? "primaryText" : "secondaryText", children: formatNumber(Number(props.value), 6) || "" }), _jsx(TokenSymbol, { token: props.token, chain: props.chain, size: "sm" })] })), name ? (_jsx(Text, { size: "xs", children: name })) : (_jsx(Skeleton, { width: "90px", height: fontSize.xs }))] })] })] }));
}
//# sourceMappingURL=PayWithCrypto.js.map